/* eslint-disable react/forbid-prop-types */
/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import CloseIcon from '@mui/icons-material/Close';
import { Grid2 } from '@mui/material';
import IconButton from '@mui/material/IconButton';

function TourDialog({
  driverObj,
  tourCompletion,
  setOpenDrawer,
  setDialogOpen,
  setTourOn,
}) {
  const { step } = tourCompletion.onBoarding;

  const handleClose = () => setDialogOpen(false);

  const startTour = () => {
    if (step >= 1 && step <= 6) {
      setOpenDrawer(true);
    }
    setTimeout(() => {
      driverObj.drive(tourCompletion.onBoarding.step);
      setTourOn(true);
      handleClose();
    }, 300);
  };

  return (
    <Dialog
      sx={{ width: '80%', margin: 'auto' }}
      open
      onClose={handleClose}
      PaperProps={{ style: { maxWidth: 'none' } }}
    >
      <Box style={{ padding: '30px' }}>
        <DialogTitle style={{ marginBottom: '15px' }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            color="primary"
            style={{ position: 'absolute', right: 30, top: 20 }}
            size="large"
          >
            <CloseIcon />
          </IconButton>
          <Grid2 container direction="column" alignItems="center">
            <Grid2 item style={{ marginBottom: '8px' }}>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '600',
                  fontSize: '1.3rem',
                }}
              >
                Vamos iniciar o
              </Typography>
            </Grid2>
            <Grid2 item>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '800',
                  fontSize: '2.5rem',
                }}
              >
                Tour Guiado
              </Typography>
            </Grid2>
          </Grid2>
        </DialogTitle>
        <Typography
          component="p"
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          Aqui, vamos apresentar as principais funcionalidades do nosso sistema.
          Você pode escolher o que deseja explorar, de acordo com suas
          prioridades ou preferências.
        </Typography>
        <Typography
          component="p"
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          É possível optar por um tour completo ou por etapas. Se preferir não
          ver tudo de uma vez, não se preocupe, o tour estará sempre disponível
          para você revisitar quando quiser.
        </Typography>
        <Grid2 container justifyContent="center">
          <Grid2 item style={{ margin: '25px 0 15px 0' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ fontSize: '1.2rem', width: '12em' }}
              onClick={startTour}
            >
              Vamos Lá!
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Dialog>
  );
}

TourDialog.propTypes = {
  driverObj: PropTypes.object.isRequired,
  tourCompletion: PropTypes.object.isRequired,
  setOpenDrawer: PropTypes.func.isRequired,
  setTourOn: PropTypes.func.isRequired,
};

export default TourDialog;
